import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { LogoMark } from '@/components/Ornaments';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace('#', '')).get('session_id');
    if (!sessionId) { navigate('/admin'); return; }
    api.post('/auth/session', {}, { headers: { 'X-Session-ID': sessionId } })
      .then((r) => {
        setUser(r.data);
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/admin', { state: { user: r.data } });
      })
      .catch(() => navigate('/admin'));
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-beige gap-4">
      <span className="text-terracotta w-16 h-16 animate-pulse"><LogoMark className="w-full h-full" /></span>
      <p className="text-textDark/60">…</p>
    </div>
  );
}
